import React, { useState } from 'react';
import { ArrowLeft, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const plans = {
  monthly: [
    {
      title: 'Free',
      desc: 'Explore AI with basic Q&A.',
      price: '$0',
      billed: 'Billed monthly',
      buttonText: 'Current',
      current: true,
      features: ['Limited basic queries', 'Real-time answers powered by live web search'],
    },
    {
      title: 'Pro',
      desc: 'Meet all your personal goals with expanded access to AI Agents.',
      price: '$20',
      billed: 'monthly, billed $180/year',
      buttonText: 'Get Pro',
      features: [
        'Access to all AI models from OpenAI, Anthropic, DeepSeek, Google, and more',
        'Unlock Research and custom agents',
        'Upload files & images to extract insights',
      ],
    },
    {
      title: 'Max',
      desc: 'Supercharge your productivity with the best of AI, including ARI access.',
      price: '$200',
      billed: 'monthly, billed $2100/year',
      buttonText: 'Get Max',
      features: [
        'Everything in Pro',
        'Unlimited ARI Reports',
        'Increased file upload capacity for richer research and more complex tasks',
        'Zero data retention and no-training for models',
      ],
    },
  ],
  yearly: [
    {
      title: 'Free',
      desc: 'Explore AI with basic Q&A.',
      price: '$0',
      billed: 'Billed monthly',
      buttonText: 'Current',
      current: true,
      features: ['Limited basic queries', 'Real-time answers powered by live web search'],
    },
    {
      title: 'Pro',
      desc: 'Meet all your personal goals with expanded access to AI Agents.',
      price: '$20',
      billed: 'monthly, billed $180/year',
      buttonText: 'Get Pro',
      features: [
        'Access to all AI models from OpenAI, Anthropic, DeepSeek, Google, and more',
        'Upload files & images to extract insights',
      ],
    },
    {
      title: 'Max',
      desc: 'Supercharge your productivity with the best of AI, including ARI access.',
      price: '$200',
      billed: 'monthly, billed $2100/year',
      buttonText: 'Get Max',
      features: [
        'Everything in Pro',
        'Unlimited ARI Reports',
        'Increased file upload capacity for richer research and more complex tasks',
        'Zero data retention and no-training for models',
      ],
    },
  ],
};

const PlanSection = () => {
  const [activeTab, setActiveTab] = useState('monthly');
  const navigate = useNavigate();

  return (
    <div className="min-h-full p-8 lg:p-10">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-sm text-muted hover:text-[var(--text-color)] mb-8">
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-[var(--text-color)] mb-6 font-serif">Upgrade your plan</h1>
          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-[#faf9f5] border border-shell-card-border">
            {['monthly', 'yearly'].map(tab => (
              <button
                key={tab}
                type="button"
                onClick={() => setActiveTab(tab)}
                className={`px-5 py-1.5 rounded-full text-sm font-medium capitalize transition-colors ${
                  activeTab === tab ? 'bg-primary text-white' : 'text-muted hover:text-[var(--text-color)]'
                }`}>
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {plans[activeTab].map(plan => (
            <div
              key={plan.title}
              className="flex flex-col p-6 rounded-xl bg-shell-card border border-shell-card-border transition-colors hover:border-primary/40">
              <h3 className="text-lg font-semibold text-[var(--text-color)] font-serif mb-1">{plan.title}</h3>
              <p className="text-sm text-muted leading-relaxed min-h-[40px]">{plan.desc}</p>

              <div className="my-5">
                <span className="text-4xl font-bold text-[var(--text-color)]">{plan.price}</span>
                <span className="block text-xs text-muted-dim mt-1">{plan.billed}</span>
              </div>

              <button
                type="button"
                disabled={plan.current}
                className={`w-full py-2.5 rounded-full text-sm font-medium transition-colors mb-6 ${
                  plan.current
                    ? 'bg-black/[0.04] text-muted border border-shell-card-border cursor-default'
                    : 'bg-primary hover:bg-primary/90 text-white'
                }`}>
                {plan.buttonText}
              </button>

              <ul className="space-y-3 mt-auto">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-muted leading-relaxed">
                    <Check className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanSection;
